import React from 'react';

// Keep translatable segments in spans: browser translation can replace text nodes,
// so React needs an element it still owns when a segment changes or disappears.
// CEFR codes are language-neutral. Preserve their authored spacing and separators.
export const renderLevelText = (text) => {
  if (Array.isArray(text)) return text.map(renderLevelText);
  if (React.isValidElement(text) && text.props.children != null) {
    if (text.props.translate === 'no' || (typeof text.props.className === 'string' && text.props.className.split(' ').includes('notranslate'))) return text;
    return React.cloneElement(text, {}, renderLevelText(text.props.children));
  }
  if (typeof text !== 'string') return text;
  return text.split(/(\b(?:A1|A2|B1)(?:[ \t]*[-–—/][ \t]*(?:A1|A2|B1))*\b)/g).map((part, index) =>
    index % 2 ? (
      <span key={index} translate="no" className="notranslate">{part}</span>
    ) : part ? <span key={index}>{part}</span> : null,
  );
};

// These boundaries are authored explicitly; punctuation does not identify a language.
export const renderProtectedText = (text, lang) =>
  text.split(/(\[\[.*?\]\])/g).map((part, index) =>
    part.startsWith('[[') && part.endsWith(']]') ? (
      <span key={index} translate="no" className="notranslate" lang={lang}>
        {part.slice(2, -2)}
      </span>
    ) : (
      <React.Fragment key={index}>{renderLevelText(part)}</React.Fragment>
    ),
  );

export const renderExamTerms = (text, lang) =>
  text.split(/(partie lire et écrite|partie orale|Lire et ecrire|Lesen und Schreiben|FIDE Prüfung|examen fide|FIDE Wortschatz|vocabulaire fide|Parler|Comprendre|Sprechen|Verstehen)/g).map((part, index) =>
    index % 2 ? (
      <span key={index} translate="no" className="notranslate" lang={lang}>
        {part}
      </span>
    ) : (
      renderLevelText(part)
    ),
  );
